module.exports = __webpack_public_path__ + "static/media/good_photo.ee663f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sign_up/good_photo.png
// module id = 671
// module chunks = 0